import React from "react";
import { useTranslation } from "../../hooks/useTranslation";

function MenuView() {
    const { t } = useTranslation();

    const pageTitle = t('menuPage.title', 'Menukaart');
    const defaultPaymentMethods = [
        "Cash", "Bancontact", "Mastercard / Visa", "Foubert cadeaubons",
        "American Express", "Apple Pay", "Google Pay", "Maestro",
        "Discover", "Diner's Club", "Union Pay"
    ];
    const paymentMethodsRaw = t('menuPage.paymentMethods', defaultPaymentMethods);
    const paymentMethods = Array.isArray(paymentMethodsRaw) ? paymentMethodsRaw : defaultPaymentMethods;
    const sections = t('menuPage.sections', {});

    return (
        <div className="content container page-container">
            <div className="page-hero" style={{backgroundImage: "url('/images/menu/header.png')"}}>
                <div className="page-hero-overlay"></div>
            </div>

            <h1 className="page-title">{pageTitle}</h1>

            {/* Betaalmethodes */}
            <div className="content-card">
                <h3 className="section-title">
                    <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
                        <line x1="1" y1="10" x2="23" y2="10"/>
                    </svg>
                    {sections.paymentTitle || 'Betaalmethodes'}
                </h3>
                <div className="payment-grid">
                    {paymentMethods.map((method, index) => (
                        <div className="payment-item" key={index}>
                            <svg className="payment-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="20 6 9 17 4 12"/>
                            </svg>
                            {method}
                        </div>
                    ))}
                </div>
                <p style={{marginTop: '1rem', fontSize: '0.85rem', color: 'var(--text-secondary)'}}>
                    {sections.paymentNote || 'Achteraf betalen / op factuur is enkel mogelijk voor reservaties voor bedrijven (vooraf goedgekeurd).'}
                </p>
            </div>

            {/* Intro text */}
            <div className="content-card info">
                <p className="intro-text" style={{marginBottom: 0}}>
                    {sections.introText || 'Dit is onze standaard menukaart. Afhankelijk van het event, locatie of organisator kunnen deze prijzen of het aanbod afwijken.'}
                </p>
            </div>

            {/* Menu image */}
            <div className="menu-image-card">
                <img src={sections.menuImage || "/images/menu/2025_menukaart.jpg"} alt={sections.menuImageAlt || "menukaart ijs"} />
            </div>
        </div>
    );
}

export default MenuView;
